<template>
    <JobsTable v-if="$can('view', 'prepress')" :showDesigner="true" :title="t('menu.prepress')"
        icon="tabler-color-swatch" :headers="headers" type="prepress" :show-actions-menu="true">
        <!-- Custom slot for type column -->
        <template #item.type="{ item }">
            {{ getJobTypeLabel(item.type) }}
        </template>
    </JobsTable>
    <VAlert v-else type="warning" variant="tonal">
        {{ $t('admin_notifications.no_permission') }}
    </VAlert>
</template>

<script setup>
definePage({
    meta: {
        action: 'view',
        subject: 'prepress',
    },
})

import JobsTable from '@/components/polyhen/jobs/JobsTable.vue'
import { useHead } from '@unhead/vue'

const { t } = useI18n()

// Set page title
useHead({
    title: t('admin_notifications.prepress'),
    meta: [
        { name: 'description', content: t('admin_notifications.prepress_description') }
    ]
})

// Headers for prepress jobs table
const headers = computed(() => [
    {
        title: 'ID',
        key: 'id',
        sortable: false,
        width: '80px',
        align: 'right'
    },
    {
        title: 'PH',
        key: 'ph',
        sortable: false,
        width: '100px',
        align: 'right'
    },
    {
        title: t('admin_notifications.type'),
        key: 'type',
        sortable: false,
        width: '50px',
    },
    {
        title: t('admin_notifications.order'),
        key: 'order',
        sortable: false,
        width: '250px',
    },
    {
        title: t('admin_notifications.customer'),
        key: 'customer',
        sortable: false,
        width: '150px',
    },
    {
        title: t('admin_notifications.printer'),
        key: 'printer',
        sortable: false,
        width: '150px',
    },
    {
        title: t('admin_notifications.assigned'),
        key: 'assigned',
        sortable: false,
        width: '120px',
    },
    // {
    //     title: t('admin_notifications.edit_date'),
    //     key: 'created_at',
    //     sortable: false,
    //     width: '140px',

    // },
    {
        title: t('admin_notifications.status'),
        key: 'status',
        sortable: false,
        width: '140px',
    },
    {
        title: t('admin_notifications.actions'),
        key: 'actions',
        sortable: false,
        width: '100px',
    },
])

const getJobTypeLabel = (type) => {
    const labels = {
        'new': t('job.new'),
        'common': t('job.common_plates'),
        'renew': t('job.renew'),
        'duplicate': t('job.duplicate')
    }
    return labels[type] || t('job.new')
}
</script>